export const SCREEN_SIZES = {
  mobile: "600px",
  tablet: "900px",
  laptop: "1300px",
  large: "2500px",
};
